/*
 * bb-img-prop.js -- product photos for the multiple-address order email
 * (2026-11-04).
 *
 * THE PROBLEM: Multiship turns every cart line into a custom line with no
 * product link, so the order confirmation email for a multiple-address order
 * has no product photos.
 *
 * THE FIX: when a gift line is ADDED to the cart, it also carries the hidden
 * property _img = that item's photo URL. The email template shows _img when a
 * line has no image of its own. The photo rides along on the add the customer
 * is already making, so it costs no extra request and no wait.
 *
 * Only lines that already carry properties get it (every gift line does:
 * builder box, card and goodies; prebuilt box and its card). Plain lines and
 * other apps' lines are left alone.
 *
 * Where the photo comes from, first match wins:
 *   1. The box builder's catalog (BBCatalog) -- boxes, cards and goodies.
 *   2. The product page's own product JSON ([data-product-json]).
 *   2b. The cart drawer's card list ([data-bb-cart-cards]) -- the cards a
 *      prebuilt box's card add-on can be.
 *   3. A per-visit list of variant -> photo, learned from every cart response
 *      this script sees (so add-ons of something already in the cart match).
 * No photo found: the add goes through unchanged.
 *
 * Not loaded on Multiship's pages (/a/ms): bb-ms-hold.js handles those.
 * Fails open everywhere: nothing here can stop an add to cart.
 */
(function () {
  try {
    if (window.__bbImgPropInit) return;
    window.__bbImgPropInit = true;
    window.__bbImgPropBuild = "2026-11-04-v2";

    var IMG = "_img";
    var STORE = "bb_img_map_v1";
    var map = {};
    try { map = JSON.parse(sessionStorage.getItem(STORE) || "{}") || {}; } catch (_) { map = {}; }

    function clean(u) {
      if (!u || typeof u !== "string") return null;
      if (u.indexOf("//") === 0) u = "https:" + u;
      if (u.indexOf("http") !== 0) return null;
      // Drop sizing params; the email template adds its own.
      u = u.replace(/([?&])(width|height|crop)=[^&]*/g, "$1").replace(/[?&]+$/, "").replace(/\?&+/, "?").replace(/&&+/g, "&");
      return u;
    }
    function save() {
      try { sessionStorage.setItem(STORE, JSON.stringify(map)); } catch (_) {}
    }
    function learn(data) {
      try {
        var items = (data && data.items) || (data && data.variant_id ? [data] : []);
        var changed = false;
        items.forEach(function (it) {
          var u = clean(it && (it.image || (it.featured_image && it.featured_image.url)));
          if (it && it.variant_id && u && map[it.variant_id] !== u) { map[it.variant_id] = u; changed = true; }
        });
        if (changed) save();
      } catch (_) {}
    }

    var pageProduct;
    function productJson() {
      if (pageProduct !== undefined) return pageProduct;
      pageProduct = null;
      try {
        var el = document.querySelector("[data-product-json]");
        if (el) pageProduct = JSON.parse(el.textContent || el.innerHTML);
      } catch (_) { pageProduct = null; }
      return pageProduct;
    }

    var cardMap;
    function cardsJson() {
      if (cardMap !== undefined) return cardMap;
      cardMap = {};
      try {
        document.querySelectorAll("script[data-bb-cart-cards]").forEach(function (el) {
          var d = JSON.parse(el.textContent || "{}");
          (d.products || []).forEach(function (p) {
            var u = clean(p && (p.image || p.thumb || (p.images && p.images[0])));
            if (p && p.variantId && u) cardMap[String(p.variantId)] = u;
          });
        });
      } catch (_) {}
      return cardMap;
    }

    function imgFor(id) {
      var vid = String(id || "").split(":")[0];
      if (!vid) return null;
      try {
        if (window.BBCatalog && typeof BBCatalog.find === "function") {
          var p = BBCatalog.find(Number(vid)) || BBCatalog.find(vid);
          var u1 = clean(p && (p.image || p.thumb || (p.images && p.images[0])));
          if (u1) return u1;
        }
      } catch (_) {}
      try {
        var pj = productJson();
        if (pj && pj.variants) {
          for (var i = 0; i < pj.variants.length; i++) {
            var v = pj.variants[i];
            if (String(v.id) === vid) {
              var u2 = clean((v.featured_image && v.featured_image.src) || pj.featured_image || (pj.images && pj.images[0]));
              if (u2) return u2;
            }
          }
        }
      } catch (_) {}
      try {
        var cu = cardsJson()[vid];
        if (cu) return cu;
      } catch (_) {}
      return map[vid] || null;
    }

    function tag(item) {
      try {
        if (!item || typeof item !== "object") return;
        var props = item.properties;
        if (!props || typeof props !== "object" || !Object.keys(props).length) return;
        if (props[IMG]) return;
        var u = imgFor(item.id || item.variant_id);
        if (u) props[IMG] = u;
      } catch (_) {}
    }
    function tagBody(body) {
      if (!body || typeof body !== "object") return;
      if (Array.isArray(body.items)) body.items.forEach(tag);
      else tag(body);
    }
    function isAdd(url) {
      return typeof url === "string" && /(^|\/)cart\/add(\.js)?(\?|$)/.test(url.replace(location.origin, ""));
    }
    function isCartJson(url) {
      return typeof url === "string" && /(^|\/)cart(\/(add|change|update))?\.js(\?|$)/.test(url.replace(location.origin, ""));
    }

    /* ---- fetch ---- */
    var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
    if (nativeFetch) {
      window.fetch = function (input, init) {
        var url = "";
        try {
          url = typeof input === "string" ? input : (input && input.url) || "";
          if (isAdd(url) && init && init.body) {
            if (typeof init.body === "string" && init.body.trim().charAt(0) === "{") {
              var b = JSON.parse(init.body);
              tagBody(b);
              init = Object.assign({}, init, { body: JSON.stringify(b) });
            } else if (typeof FormData !== "undefined" && init.body instanceof FormData) {
              var fd = init.body;
              var hasProps = false;
              fd.forEach(function (_v, k) { if (/^properties\[/.test(k)) hasProps = true; });
              if (hasProps && !fd.has("properties[" + IMG + "]")) {
                var u = imgFor(fd.get("id"));
                if (u) fd.append("properties[" + IMG + "]", u);
              }
            }
          }
        } catch (_) {}
        var p = nativeFetch(input, init);
        try {
          if (isCartJson(url)) {
            p.then(function (res) {
              try { if (res && res.ok) res.clone().json().then(learn, function () {}); } catch (_) {}
            }, function () {});
          }
        } catch (_) {}
        return p;
      };
    }

    /* ---- XMLHttpRequest ---- */
    try {
      var XO = XMLHttpRequest.prototype.open;
      var XS = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (method, url) {
        try { this.__bbImgUrl = String(url || ""); } catch (_) {}
        return XO.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function (body) {
        var xhr = this;
        try {
          if (isAdd(xhr.__bbImgUrl) && typeof body === "string") {
            var t = body.trim();
            if (t.charAt(0) === "{") {
              var b = JSON.parse(t);
              tagBody(b);
              body = JSON.stringify(b);
            } else if (/(^|&)properties(%5B|\[)/.test(t) && !/properties(%5B|\[)_img(%5D|\])=/.test(t)) {
              var id = null;
              t.split("&").forEach(function (pair) {
                var kv = pair.split("=");
                if (kv[0] === "id") id = decodeURIComponent(kv[1] || "");
              });
              var u = imgFor(id);
              if (u) body = t + "&" + encodeURIComponent("properties[" + IMG + "]") + "=" + encodeURIComponent(u);
            }
          } else if (isAdd(xhr.__bbImgUrl) && typeof FormData !== "undefined" && body instanceof FormData) {
            var hasP = false;
            body.forEach(function (_v, k) { if (/^properties\[/.test(k)) hasP = true; });
            if (hasP && !body.has("properties[" + IMG + "]")) {
              var u2 = imgFor(body.get("id"));
              if (u2) body.append("properties[" + IMG + "]", u2);
            }
          }
          if (isCartJson(xhr.__bbImgUrl)) {
            xhr.addEventListener("load", function () {
              try { if (xhr.status >= 200 && xhr.status < 300) learn(JSON.parse(xhr.responseText)); } catch (_) {}
            });
          }
        } catch (_) {}
        return XS.call(this, body);
      };
    } catch (_) {}

    /* ---- plain form posts to /cart/add (no script involved) ---- */
    document.addEventListener("submit", function (e) {
      try {
        var f = e.target;
        if (!f || !f.getAttribute) return;
        var action = f.getAttribute("action") || "";
        if (!isAdd(action.split("#")[0])) return;
        if (!f.querySelector("[name^='properties[']")) return;
        if (f.querySelector("[name='properties[" + IMG + "]']")) return;
        var idEl = f.querySelector("[name='id']");
        var u = imgFor(idEl && idEl.value);
        if (!u) return;
        var input = document.createElement("input");
        input.type = "hidden";
        input.name = "properties[" + IMG + "]";
        input.value = u;
        f.appendChild(input);
      } catch (_) {}
    }, true);

  } catch (_) {}
})();
